export default __webpack_public_path__ + "static/media/banner_home.40797af3.jpg";